import { ChatMap, ChatsMutations, MessageMap } from './types'

const mutations: ChatsMutations = {
  setChats(state, chats: ChatMap): void {
    state.chats = chats
  },
  setMessages(state, messages: MessageMap): void {
    state.messages = messages
  },
}

export default mutations
